import MyTabs from '../../components/MyTabs';
import QuestionDetailForm from './QuestionDetailForm';

const GeneralQuestions = () => {

    const tabs = [
        { id: "basic", title: "Question Info", Component: QuestionDetailForm },
    ];

    return (
        <>
            <MyTabs list={tabs} />
        </>
    )
};

export default GeneralQuestions;